import React from "react";
import { createBottomTabNavigator } from "@react-navigation/bottom-tabs";
import { Dimensions, TouchableOpacity, View, Text } from "react-native";
import Ionicons from "react-native-vector-icons/Ionicons";

import Home from "../Home";
import Map from "../Map";
import ScanQRCode from "../../components/ScanQRCode";
import CardsList from "../Wallet";
import Perfil from "../Perfil/Perfil";
import * as Colors from "../../styles/colors";

const { width } = Dimensions.get("window");
const BUTTON_SIZE = 64;

export default function Menu() {
  const Tab = createBottomTabNavigator();

  return (
    <Tab.Navigator
      initialRouteName="Carteira"
      screenOptions={({ route }) => ({
        headerShown: false,
        tabBarActiveTintColor: Colors.SECONDARY,
        tabBarInactiveTintColor: Colors.GRAY_DARK,
        tabBarHideOnKeyboard: true,

        // Make the tabBar itself a positioned container:
        tabBarStyle: {
          position: "relative",
          backgroundColor: Colors.WHITE,
          height: 64,
          borderTopWidth: 1,
          borderTopColor: "#eee",
        },
        tabBarLabelStyle: {
          fontSize: 11,
          fontWeight: "600",
          marginBottom: 4,
        },

        // Default icon logic for all tabs *except* PaymentQRCode:
        tabBarIcon: ({ focused, color }) => {
          if (route.name === "PaymentQRCode") return null;

          let iconName;
          switch (route.name) {
            case "Inicio":
              iconName = focused ? "home-sharp" : "home-outline";
              break;
            case "Unidades":
              iconName = focused ? "car" : "car-outline";
              break;
            case "Carteira":
              iconName = focused ? "wallet" : "wallet-outline";
              break;
            case "Perfil":
              iconName = focused ? "person-sharp" : "person-outline";
              break;
          }
          return <Ionicons name={iconName} size={24} color={color} />;
        },
      })}
    >
      <Tab.Screen
        name="Inicio"
        component={Home}
        options={{ title: "Início" }}
      />

      <Tab.Screen
        name="Unidades"
        component={Map}
        options={{ title: "Unidades" }}
      />

      {/* === Pagar button: only this tab uses a custom button === */}
      <Tab.Screen
        name="PaymentQRCode"
        component={ScanQRCode}
        options={{
          tabBarLabel: "",       // hide default text
          tabBarIcon: () => null, // no default icon

          // custom tabBarButton absolutely placed in the bar container
          tabBarButton: (props) => (
            <TouchableOpacity
              {...props}
              style={{
                position: "absolute",
                left: (width - BUTTON_SIZE) / 2, // center horizontally
                top: -20,                        // lift above bar
                width: BUTTON_SIZE,
                height: BUTTON_SIZE,
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {/* big colored circle */}
              <View
                style={{
                  width: BUTTON_SIZE,
                  height: BUTTON_SIZE,
                  borderRadius: BUTTON_SIZE / 2,
                  backgroundColor: Colors.SECONDARY,
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Ionicons name="logo-usd" size={32} color={Colors.WHITE} />
              </View>

              {/* custom label below */}
              <Text
                style={{
                  position: "absolute",
                  bottom: -18,
                  fontSize: 11,
                  fontWeight: "600",
                  color: Colors.SECONDARY,
                }}
              >
                Pagar
              </Text>
            </TouchableOpacity>
          ),
        }}
      />

      <Tab.Screen
        name="Carteira"
        component={CardsList}
        options={{ title: "Carteira" }}
      />

      <Tab.Screen
        name="Perfil"
        component={Perfil}
        options={{ title: "Perfil" }}
      />
    </Tab.Navigator>
  );
}